import Index from "./Index.vue";
import Edit from "./Edit.vue";
import New from "./New.vue";
import Show from "./Show.vue";
import ManagementIndex from "./ManagementIndex.vue";
import ChangePassword from "./ChangePassword.vue";
import Unsubscribe from "./Unsubscribe.vue";
import { Router as BcpRouter, Root as BcpRoot } from "./BCP";
import { Router as InquiriesRouter, Root as InquiriesRoot } from "./Inquiries";
import { Router as MagazinesRouter, Root as MagazinesRoot } from "./Magazines";
import { Root as NewsRoot, Router as NewsRouter } from "./News";
import {
  Root as OrganizationsRoot,
  Router as OrganizationsRouter,
} from "./Organizations";
import { Root as PasswordRoot, Router as PasswordRouter } from "./Password";
import { Root as RulesRoot, Router as RulesRouter } from "./Rules";
import { Root as Invest24Root, Router as Invest24Router } from "./Invest24";
import { Root as SponsorsRoot, Router as SponsorsRouter } from "./Sponsors";
import {
  Root as SystemAdmin,
  Router as SystemAdminRouter,
} from "./SystemAdmin";
import { Root as TrainingsRoot, Router as TrainingsRouter } from "./Trainings";
import Management from "./Invest24/Managements/Management.vue";

export default [
  {
    path: "",
    name: "UsersIndex",
    component: Index,
    meta: {
      title: "会員メニュー",
      subtitle: "USER MENU",
      tree: [],
    },
  },
  {
    path: "edit",
    name: "UsersEdit",
    component: Edit,
    meta: {
      title: "編集",
      subtitle: "USER INFO",
      tree: [
        {
          name: "UsersShow",
          title: "マイページ",
        },
        {
          title: "編集",
        },
      ],
    },
  },
  {
    path: "new",
    name: "UsersNew",
    component: New,
    meta: {
      title: "会員代理追加",
      subtitle: "ADD USER",
      tree: [
        {
          name: "UsersManagementIndex",
          title: "管理者メニュー",
        },
        {
          name: "UsersSystemAdminUsers",
          title: "会員管理",
        },
      ],
    },
  },
  {
    path: "change_password",
    name: "UsersChangePassword",
    component: ChangePassword,
    meta: {
      title: "パスワード変更",
      subtitle: "CHANGE PASSWORD",
      tree: [
        {
          name: "UsersShow",
          title: "マイページ",
        },
        {
          title: "パスワード変更",
        },
      ],
    },
  },
  {
    path: "unsubscribe",
    name: "UsersUnsubscribe",
    component: Unsubscribe,
    meta: {
      title: "アカウントの退会手続き",
      subtitle: "UNSUBSCRIBE",
      tree: [
        {
          name: "UsersShow",
          title: "マイページ",
        },
        {
          title: "退会",
        },
      ],
    },
  },
  {
    path: "show",
    name: "UsersShow",
    component: Show,
    meta: {
      title: "マイページ",
      subtitle: "MYPAGE",
      tree: [
        {
          title: "マイページ",
        },
      ],
    },
  },
  {
    path: "managements",
    name: "UsersManagementIndex",
    component: ManagementIndex,
    meta: {
      title: "管理者メニュー",
      subtitle: "MANAGEMENT MENU",
      tree: [],
    },
  },
  {
    path: "bcp",
    component: BcpRoot,
    children: BcpRouter,
  },
  {
    path: "inquiries",
    component: InquiriesRoot,
    children: InquiriesRouter,
  },
  {
    path: "magazines",
    component: MagazinesRoot,
    children: MagazinesRouter,
  },
  {
    path: "news",
    component: NewsRoot,
    children: NewsRouter,
  },
  {
    path: "organizations",
    component: OrganizationsRoot,
    children: OrganizationsRouter,
  },
  {
    path: "password",
    component: PasswordRoot,
    children: PasswordRouter,
  },
  {
    path: "rules",
    component: RulesRoot,
    children: RulesRouter,
  },
  {
    path: "sponsors",
    component: SponsorsRoot,
    children: SponsorsRouter,
  },
  {
    path: "system_admin",
    component: SystemAdmin,
    children: SystemAdminRouter,
  },
  /*
  {
    path: "invest24",
    component: Invest24Root,
    children: Invest24Router,
  },
*/
  {
    path: "trainings",
    component: TrainingsRoot,
    children: TrainingsRouter,
  },
];
